import { callOptionalFc } from "../../helper/callOptionalFc"

export enum MomentCardState {
    TO_EDIT = 'TO_EDIT',
    UPDATE = 'UPDATE',
    CANCEL = 'CANCEL',
    SAVE = 'SAVE',
    LOADING = 'LOADING'
}

interface EventsCard {
    eventOnClose?: () => void
    eventOnHide?: () => void
    eventOnOpen?: () => void
    eventOnSave?: () => void
}
interface MomentToEdit {
    type: MomentCardState.TO_EDIT
}
interface MomentUpdate<T> {
    type: MomentCardState.UPDATE
    form: T
}

interface MomentCancel<T> {
    type: MomentCardState.CANCEL
    form: T
}
interface MomentLoading {
    type: MomentCardState.LOADING
}
interface MomentSave {
    type: MomentCardState.SAVE
}
export interface CardState<T> {
    editMode: boolean
    loading: boolean
    draftForm: T
    events?: EventsCard
}

export type Moments<T> = MomentToEdit | MomentSave | MomentLoading | MomentUpdate<T> | MomentCancel<T>

export default function <T>(state: CardState<T>, action: Moments<T>): CardState<T> {
    switch (action.type) {
        case MomentCardState.TO_EDIT:            
            callOptionalFc(state?.events.eventOnOpen) 
            return {
                editMode: true,
                loading: false,
                draftForm: state.draftForm,
                events: state?.events
            }
        case MomentCardState.UPDATE:
            return {
                loading: false,
                editMode: true,
                draftForm: action.form,
                events: state?.events
            }
        case MomentCardState.CANCEL:
            callOptionalFc(state?.events.eventOnClose)
            callOptionalFc(state?.events.eventOnHide)        
            return {
                loading: false,
                editMode: false,
                draftForm: action.form,
                events: state?.events
            }
        case MomentCardState.LOADING:
            return {
                loading: true,
                editMode: true,
                draftForm: state.draftForm,
                events: state?.events
            }
        case MomentCardState.SAVE:
            callOptionalFc(state?.events.eventOnSave) 
            callOptionalFc(state?.events.eventOnHide) 
            return {
                loading: false,
                editMode: false,
                draftForm: state.draftForm,
                events: state?.events
            }
        default:
            return state
    }
}
